import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ConferenceStatResource } from 'src/app/models/iconference.interface';

@Component({
  selector: 'app-conf-stat-registered-table',
  templateUrl: './conf-stat-registered-table.component.html',
  styleUrl: './conf-stat-registered-table.component.css'
})
export class ConfStatRegisteredTableComponent {
  @Input() data: ConferenceStatResource
}
